if (!customElements.get('ctr-steps')) {
  class CtrSteps extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.cacheElements();
      this.bindEvents(signal);
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }
    }

    cacheElements() {
      this.steps = this.querySelectorAll('[data-ctr-step]');
      this.mediaSlides = this.querySelectorAll('[data-ctr-step-media]');
    }

    bindEvents(signal) {
      this.steps.forEach((step) => {
        const trigger = step.querySelector('.ctr-steps__step-trigger');
        if (!trigger) return;

        trigger.addEventListener(
          'click',
          () => {
            this.activateStep(step);
          },
          { signal }
        );
      });

      document.addEventListener(
        'shopify:section:load',
        (event) => {
          if (!event.target || !event.target.contains(this)) return;
          this.cacheElements();
        },
        { signal }
      );

      document.addEventListener(
        'shopify:block:select',
        (event) => {
          if (!this.contains(event.target)) return;
          const step = event.target.closest('[data-ctr-step]');
          if (!step) return;
          this.activateStep(step);
        },
        { signal }
      );
    }

    activateStep(activeStep) {
      const activeId = activeStep.getAttribute('data-block-id');

      this.steps.forEach((step) => {
        const isActive = step === activeStep;
        const trigger = step.querySelector('.ctr-steps__step-trigger');
        const panel = step.querySelector('.ctr-steps__step-text');

        step.classList.toggle('is-active', isActive);

        if (trigger) {
          trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }

        if (panel) {
          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        }
      });

      this.mediaSlides.forEach((slide) => {
        const isActive = slide.getAttribute('data-ctr-step-media') === activeId;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }
  }

  customElements.define('ctr-steps', CtrSteps);
}
